export default function blogSchemaGenre (docType) {
    switch (docType) {
        case 'tech-data': return 'Dane techniczne samochodów'
        case 'make-history': return 'Historia marek samochodowych'
        case 'car-selling': return 'Ogłoszenia motoryzacyjne'
        case 'used-cars': return 'Samochody używane'
        case 'new-cars': return 'Samochody nowe'
        case 'hybrid-cars': return 'Samochody hybrydowe'
        case 'electric-cars': return 'Samochody elektryczne'
        case 'cars-for-parts': return 'Samochody na części'
        case 'car-installment': return 'Samochody i pojazdy na raty'
        case 'car-insurance': return 'Ubezpieczenie samochodu'
        default: return 'Aktualności dostawczaki.pl'
    }
}